import BaseHelper from './BaseHelper'
import { select as d3_select } from 'd3-selection'
export default class SelectableHelper extends BaseHelper {
  static configName = 'SelectableHelper'

  static defaultConfig = {
    index: 103,
    /**
     * {-EN-} Enable/disable selection of the items. When enabled, items will be highlighted on click/tap.
     * {-ES-} Activar/desactivar la selección de los elementos. Cuando esté habilitado, los elementos se resaltarán al hacer clic/tocar.
     */
    enableSelection: {
      type: Boolean,
      default: true,
      exposed: true,
    },
  }
  static init() {
    this.selection = []
    let self = this
    d3_select(this.$root).on('click', (e, d) => {
      if (e.currentTarget === e.target) {
        self.selection = []
        self.$root.dispatchEvent(new MouseEvent('mouseover'))
        self._updateSelection()
      }
    })
  }
  static beforeDraw() {
    //Reset interactive nodes selected for linecharts
    if (!this.config.highlightNodeOnClick && !!this._interactiveHighlightedNodes) {
      this._interactiveHighlightedNodes = {}
    }
  }
  static afterDraw() {
    let itemsEnter = this.itemsEnter
    let linesItemsEnter = this.linesItemsEnter
    let barsItemsEnter = this.barsItemsEnter
    const entersGroup = [itemsEnter, linesItemsEnter, barsItemsEnter]
    let self = this
    entersGroup.forEach(enters => {
      if (enters) {
        enters.on('click', (e, d) => {
          const selectedItem = d
          if (d.parentId) {
            if (self.data.lines) {
              d =
                self.data.lines.find(dd => dd.id === d.parentId) ||
                self.data.bars.find(dd => dd.id === d.parentId)
            } else {
              d = self.data.find(dd => dd.id === d.parentId)
            }
            if (this.config.highlightNodeOnClick) {
              if (!self._interactiveHighlightedNodes) {
                self._interactiveHighlightedNodes = {}
              }
              if (self._interactiveHighlightedNodes[selectedItem.parentId] === selectedItem.id)
                delete self._interactiveHighlightedNodes[selectedItem.parentId]
              else self._interactiveHighlightedNodes[selectedItem.parentId] = selectedItem.id
              //Hay mejor forma de hacerlo???
              self._draw()
            }
          }
          self._setSelection(e, d)
          e.currentTarget.dispatchEvent(new MouseEvent('mousemove'))
          e.target.dispatchEvent(new MouseEvent('mousemove'))
        })
      }
    })

    // update para cuando cambiamos la prop (no podemos hacer siempre xk se estropean las transitions...)
    if (!this.config.SelectableHelper.enableSelection && this.selection.length)
      this._updateSelection()
  }
  static _updateSelection = function (options = {}) {
    // Bastante guarrero, pero efectivo!
    if (!this.config.SelectableHelper.enableSelection) this.selection = []

    let items =
      (this.parentItems && this.parentItems.merge(this.parentItemsEnter)) ||
      (this.items && this.items.merge(this.itemsEnter))
    const lineParentItems =
      this.linesParentItems && this.linesParentItems.merge(this.linesParentItemsEnter)
    const barsParentItems =
      this.barsParentItems && this.barsParentItems.merge(this.barsParentItemsEnter)

    const selectionGroups = []
    items && selectionGroups.push(items)
    lineParentItems && selectionGroups.push(lineParentItems)
    barsParentItems && selectionGroups.push(barsParentItems)

    let self = this
    selectionGroups.forEach(selectionItems => {
      if (this.selection.length) {
        let trans = selectionItems
          .transition('select-trans')
          .duration(200)
          .style('opacity', dd => {
            return this.selection.indexOf(dd) >= 0 ? 1 : 0.3
          })

        if (this.setSelectedFunc) {
          trans.each(function (dd) {
            if (self.selection.indexOf(dd) >= 0)
              d3_select(this).call(self.setSelectedFunc.bind(self), dd)
            else d3_select(this).call(self.unsetSelectedFunc.bind(self), dd)
          })
        }
      } else {
        let trans = selectionItems.transition('select-trans').duration(200).style('opacity', 1)

        if (this.unsetSelectedFunc) {
          trans.each(function (dd) {
            d3_select(this).call(self.unsetSelectedFunc.bind(self), dd)
          })
        }
      }
    })
    if (!options.silent) this.emit('select', this.selection)
  }
  static _setSelection = function (e, d, options = {}) {
    if (!d) this.selection = []
    else if (this.selection.indexOf(d) >= 0) this.selection = this.selection.filter(dd => dd !== d)
    else this.selection = [d] //this.selection.push(d)

    this._updateSelection(options)
  }

  static selectById = function (id) {
    this._setSelection(
      null,
      this.data.find(d => d.id === id),
      { silent: true }
    )
  }
}
